import React from "react";
import { cn } from "@/lib/utils";

// Section — shared layout wrapper for all non-hero page sections.
//
// Phase 10 spacing audit: previous scale was too generous for the site's
// editorial-but-conversion-driven brief, especially when two `normal`
// sections stacked (224 + 224 = 448px of vertical padding on desktop —
// read as "empty screen scroll" rather than "premium breathing room").
//
// New scale:
//   tight:  py-10  sm:py-14         (mobile 40px / sm+ 56px each side)
//   normal: py-12  sm:py-16  lg:py-20 (mobile 48px / sm 64px / lg 80px) ← default for nearly all sections
//   loose:  py-16  sm:py-20  lg:py-24 (only for genuinely atmospheric pauses)
//   none:   ""                       (caller fully owns spacing)
//
// Two stacked `normal` sections on desktop now consume 320px (was 448px) —
// ~28% reduction in dead vertical scroll. Mobile reduces from 224px to
// 192px per pair.
export const Section = ({ children, className, id, container = true, spacing = "normal", ...rest }) => {
    const spacings = {
        tight:  "py-10 sm:py-14",
        normal: "py-12 sm:py-16 lg:py-20",
        loose:  "py-16 sm:py-20 lg:py-24",
        none:   "",
    };
    return (
        <section id={id} className={cn("relative", spacings[spacing], className)} {...rest}>
            {container ? (
                <div className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-10">{children}</div>
            ) : (
                children
            )}
        </section>
    );
};

export const Kicker = ({ children, className }) => (
    <span className={cn("kicker", className)}>{children}</span>
);

export const SerifTitle = ({ children, as: As = "h2", className }) => (
    <As className={cn("font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05]", className)}>{children}</As>
);

export const HairlineBrass = ({ className }) => (
    <span className={cn("inline-block h-px w-10 bg-[hsl(var(--lux-brass))]", className)} />
);
